query ListYouTubeWaitlist($limit: Int, $nextToken: String) {
  page: StreamToolsListYouTubeWaitlist(limit: $limit, nextToken: $nextToken) {
    items {
      accountId
      email
      youtubeWaitlistAt
      youtubeDemoExempt
    }
    nextToken
    totalWaiting
  }
}
